import * as React from "react";
import { Helmet } from 'react-helmet';
import Utility from "Core/Utility";
import Recaptcha from 'react-recaptcha';
import Form, { FormComponentProps } from "antd/lib/form";

export interface Props {
    children?: React.ReactNode
    onChange?: Function;
    reCaptchaID: string;
}

export interface State {
}

export default class ReCaptcha extends React.Component<Props, State> {
    recaptchaRef = React.createRef<Recaptcha>();
    constructor(props: Props) {
        super(props)

        this.state = {
        }
    };

    verifyCallback = (response) => {
        const { onChange } = this.props;

        //updates application about the recaptcha state onVerify and set field value to response
        if (onChange) {
            onChange(response);
        };
    };

    reset = () => {
        if (this.recaptchaRef.current) {
            this.recaptchaRef.current.reset();
        }
        this.setValueToNull();
    }

    setValueToNull() {
        const { onChange } = this.props;

        //updates application about the recaptcha state on expiry and resets the field value
        if (onChange) {
            onChange();
        }
    }

    onExpiredCallback = () => {
        this.setValueToNull();
    };

    //onloadCallback & render=explicit is to get back a reponse in verifyCallback
    RecaptchaItem = <Recaptcha
        ref={this.recaptchaRef}
        elementID={this.props.reCaptchaID}
        sitekey={Utility.ReCaptureSiteKey()}
        render="explicit"
        onloadCallback={() => { }}
        verifyCallback={this.verifyCallback}
        expiredCallback={this.onExpiredCallback}
    />

    render() {
        return (
            <>
                <Helmet>
                    <script src="https://www.google.com/recaptcha/api.js" async defer></script>
                </Helmet>
                {this.RecaptchaItem}
            </>
        )
    }
}
